module.exports = __webpack_public_path__ + "static/media/error.f40bdec4.mp3";